<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import StepProgress from "@/components/widgets/StepProgress";
import Datatable from "@/router/layouts/table-datatable.vue";
import appConfig from "@/app.config";
import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";
import ModalImagePreview from "../master-soal-verifikasi/ModalImagePreview.vue";
import ModalSoalPreview from "../master-soal-verifikasi/ModalSoalPreview.vue";

const REVIEW_STEPS = [
  { key: "PENDING", label: "Pending", desc: "Menunggu", icon: "fa fa-clock", color: "warning" },
  { key: "REVISION", label: "Revision", desc: "Perlu Revisi", icon: "fa fa-redo", color: "danger" },
  { key: "REPAIRED", label: "Repaired", desc: "Sudah Diperbaiki", icon: "fa fa-tools", color: "primary" },
  { key: "COMPLETED", label: "Completed", desc: "Selesai", icon: "fa fa-check", color: "success" },
];

export default {
  page: {
    title: "Monitoring Review Soal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    StepProgress,
    Datatable,
    ModalImagePreview,
    ModalSoalPreview,
  },
  computed: {
    tipeNormalized() {
      return this.previewDataSoal?.tipe?.toLowerCase() || "";
    },

    isObjectiveType() {
      return ["pilihan ganda", "benar salah"].includes(this.tipeNormalized);
    },

    isMatchingType() {
      return this.tipeNormalized === "menjodohkan";
    },

    isEssayType() {
      return ["text", "essay", "essai"].includes(this.tipeNormalized);
    },

    hasUnrepairedRevision() {
      return this.table_data.some((row) => row.status_review === "REVISION");
    },

    canSubmitPerbaikan() {
      return (
        this.statusReviewKompetensi === "REVISION" &&
        this.table_data.length > 0
      );
    },

    columns() {
      return [
        { width: "50px", label: "No", name: "-" },
        { width: "100px", label: "Nomor Soal", name: "-" },
        { width: "auto", label: "Tipe", name: "-" },
        { width: "auto", label: "Soal Gambar", name: "-" },
        { width: "auto", label: "Pertanyaan", name: "-" },
        { width: "auto", label: "Jumlah Jawaban", name: "-" },
        { width: "auto", label: "Sumber", name: "-" },
        { width: "auto", label: "Status Review", name: "-" },
        { width: "auto", label: "Catatan", name: "-" },
        { width: "180px", label: "Aksi", name: "-" },
      ];
    },
    sortOrders() {
      let sortOrders = [];

      this.columns.forEach((column) => {
        sortOrders[column.name] = -1;
      });
      return sortOrders;
    },
  },
  data() {
    return {
      title: "Monitoring Review Soal",
      link: process.env.VUE_APP_BACKEND_URL,
      isLoading: true,
      table_data: [],
      sortKey: "kompetensi_idkompetensi",
      search: "",
      idKompetensi: this.$route.params.id,
      kompetensi: {},
      statusReviewKompetensi: "PENDING",
      reviewSteps: REVIEW_STEPS,
      showModalImagePreview: false,
      showModalSoalPreview: false,
      previewUrl: "",
      previewDataSoal: null,
      searchDebounced: () => {},
    };
  },
  mounted() {
    this.getKompetensi();
    this.getReviewKompetensiStatus();
    this.getData();
    this.searchDebounced = _.debounce(() => this.getData(), 500);
  },
  methods: {
    async getKompetensi() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/kompetensi-level/" +
          this.idKompetensi,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          Accept: `Application/json`,
        },
      }).then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
      }
    },
    async getReviewKompetensiStatus() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/review-soal/" +
          this.idKompetensi,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          Accept: "Application/json",
        },
      }).then((response) => response.data.data);

      if (data?.status_review) {
        this.statusReviewKompetensi = data.status_review;
      }
    },
    reviewSoal(row) {
      this.$router.push({
        name: "review-monitoring-perbaikan-form",
        params: {
          id: this.idKompetensi,
          idReviewSoal: row.idreview_soal,
        },
      });
    },
    async submitPerbaikan() {
      if (this.hasUnrepairedRevision) {
        Swal.fire({
          icon: "warning",
          title: "Masih Ada Soal Revisi",
          text: "Selesaikan perbaikan semua soal berstatus REVISION terlebih dahulu sebelum mengirim hasil perbaikan.",
        });
        return;
      }

      const result = await Swal.fire({
        icon: "question",
        title: "Kirim Hasil Perbaikan?",
        text: "Semua soal yang direvisi akan dikirim sebagai hasil perbaikan ke reviewer.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Ya, Kirim",
        denyButtonText: "Batal",
      });

      if (!result.isConfirmed) return;

      Swal.fire({
        title: "Memproses...",
        text: "Sedang mengirim hasil perbaikan",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await axios({
          method: "post",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            `verifikasi/review-perbaikan-soal/${this.idKompetensi}/submit`,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Hasil perbaikan berhasil dikirim.",
          timer: 1500,
          showConfirmButton: false,
        });

        this.getData();
        this.getReviewKompetensiStatus();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text:
            error.response?.data?.meta?.message ||
            "Terjadi kesalahan saat mengirim hasil perbaikan.",
        });
      }
    },
    async getData() {
      this.isLoading = true;
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "verifikasi/review-monitoring/" +
          this.idKompetensi +
          "/soal",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            const rows = response_data.data || [];
            const keyword = this.search.trim().toLowerCase();
            this.table_data = keyword
              ? rows.filter((row) =>
                  (row.pertanyaan || "").toLowerCase().includes(keyword),
                )
              : rows;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    previewImage(url) {
      this.previewUrl = url;
      this.showModalImagePreview = true;
    },
    previewSoal(row) {
      this.previewDataSoal = row;
      this.showModalSoalPreview = true;
    },
    previewOriginal(row) {
      this.previewDataSoal = row.original;
      this.showModalSoalPreview = true;
    },

    getImageUrl(path) {
      return this.link + path;
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title">Soal</div>
                  <div>
                    <span class="font-weight-bold">Kode Kompetensi :</span>
                    <br />
                    <strong>{{
                      kompetensi?.kompetensi?.kode_kompetensi || "-"
                    }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{
                      kompetensi?.kompetensi?.nama_kompetensi || "-"
                    }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2">
                  <router-link
                    class="btn btn-secondary btn-sm"
                    :to="{ name: 'review-monitoring-kompetensi-level' }"
                  >
                    <i class="fa fa-arrow-left me-1"></i> Kembali
                  </router-link>
                  <button
                    class="btn btn-warning btn-sm"
                    v-if="canSubmitPerbaikan"
                    :disabled="hasUnrepairedRevision"
                    :title="
                      hasUnrepairedRevision
                        ? 'Masih ada soal berstatus REVISION yang belum diperbaiki'
                        : ''
                    "
                    @click="submitPerbaikan"
                  >
                    <i class="fa fa-paper-plane me-1"></i>
                    Kirim Hasil Perbaikan
                  </button>
                </div>
              </div>
              <div class="col-12">
                <hr />
                <StepProgress
                  :currentStatus="statusReviewKompetensi"
                  :steps="reviewSteps"
                />
              </div>
              <div class="col-12">
                <hr />
              </div>
            </div>

            <div class="d-flex justify-content-end mb-2">
              <div style="max-width: 50%; width: 500px">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="searchTable"
                  placeholder="Cari Data ..."
                  v-model="search"
                  @input="searchDebounced()"
                />
              </div>
            </div>
            <div class="row">
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="isLoading">
                    <td class="text-center" colspan="99">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="table_data == ''">
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row_data, key_data) in table_data"
                    :key="key_data"
                  >
                    <td>{{ key_data + 1 }}</td>
                    <td>{{ row_data.nomor_urut ?? "-" }}</td>
                    <td>{{ row_data.tipe }}</td>
                    <td>
                      <div
                        class="container-image"
                        v-if="row_data.pertanyaan_gambar"
                      >
                        <img
                          v-if="row_data.pertanyaan_gambar"
                          :src="link + row_data.pertanyaan_gambar"
                          class="image"
                        />
                        <div
                          class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                        >
                          <button
                            class="btn btn-success btn-sm"
                            @click="
                              previewImage(link + row_data.pertanyaan_gambar)
                            "
                          >
                            <i class="fa fa-search"></i> Preview
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>{{ row_data.pertanyaan }}</td>
                    <td class="text-center">
                      {{ row_data.jawaban?.length ?? 0 }}
                    </td>
                    <td>
                      <span
                        class="badge font-size-12"
                        :class="row_data.is_repaired ? 'bg-info' : 'bg-secondary'"
                      >
                        {{ row_data.is_repaired ? "Perbaikan" : "Original" }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge font-size-12"
                        :class="{
                          'bg-warning':
                            !row_data.status_review ||
                            row_data.status_review === 'PENDING',
                          'bg-danger': row_data.status_review === 'REVISION',
                          'bg-info': row_data.status_review === 'REPAIRED',
                          'bg-success': row_data.status_review === 'COMPLETED',
                        }"
                      >
                        {{ row_data.status_review || "PENDING" }}
                      </span>
                    </td>
                    <td>{{ row_data.catatan_review || "-" }}</td>
                    <td>
                      <div class="d-flex gap-1 justify-content-center">
                        <button
                          class="btn btn-info btn-sm"
                          @click="previewSoal(row_data)"
                        >
                          <i class="fa fa-search me-1"></i> Preview
                        </button>
                        <button
                          class="btn btn-secondary btn-sm"
                          v-if="row_data.is_repaired"
                          @click="previewOriginal(row_data)"
                        >
                          <i class="fa fa-history me-1"></i> Lihat Original
                        </button>
                        <button
                          class="btn btn-warning btn-sm"
                          v-if="row_data.status_review === 'REVISION' && row_data.idreview_soal"
                          @click="reviewSoal(row_data)"
                        >
                          <i class="fa fa-wrench me-1"></i> Perbaiki
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>

  <ModalImagePreview v-model="showModalImagePreview" :url="previewUrl" />

  <ModalSoalPreview
    v-model="showModalSoalPreview"
    :data="previewDataSoal"
    :link="link"
  />
</template>
